module.exports = __webpack_public_path__ + "static/media/Tool-LHS-TREE_IMG.c3029c75.png";